import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import ProfileList from '../../components/ProfileList';
import CategoryList from '../../components/CategoryList';
import PortalBanner from "../../components/PortalBanner/index";
import PortalBannerSlide from "../../components/PortalBannerSlide/index";
import LoadSpinner from "../../components/LoadSpinner/index";

export class FindFriendView extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.fetchProfileRise = this.fetchProfileRise.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    const { categories, firstTab, scrollTop } = this.props;
    if (firstTab !== 'friend' && categories.size === 0) {
      this.props.fetchCategories();
      this.props.fetchEvents();
      this.props.fetchProfilesRecommendRandom();
      this.props.fetchProfilesRise();
      // PFPROJ-44: 추천, 플친만들기 영역 제거
      // this.props.renderRecommendsBox();
      // this.props.renderPfCenterBox();
    }
    document.body.scrollTop = document.documentElement.scrollTop = scrollTop;
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const container = ReactDOM.findDOMNode(this);
    if (window.pageYOffset + window.innerHeight >= container.offsetHeight + container.offsetTop) {
      this.fetchProfileRise();
    }
  }

  fetchProfileRise() {
    const { profileRise, profileRiseRenderCount, isRiseFetching } = this.props;
    if (isRiseFetching || profileRise.size <= profileRiseRenderCount) {
      return;
    }
    this.props.scrollProfileRecommendRequest();
    setTimeout(() => {
      this.props.scrollProfileRecommendSuccess();
    }, 50);
  }

  renderRecommendsBox() {
    const { device, profileRecommends } = this.props;
    return (
      <div>
        <a name="recommend" className="anchor"></a>
        <div className="box_plus" data-tiara-layer="recommend_box">
          <ProfileList
            device={device}
            profiles={profileRecommends}
            isNoTitle={Boolean(false)}
            title="추천"
            titleLink="/portal/recommends"
            reduxProfileNames={['profileRecommends', 'profileRise']}
          />
        </div>
      </div>
    );
  }

  renderPfCenterBox() {
    const { pfCenterMobileUrl } = this.props;
    return (
     <div className="box_plus" data-tiara-layer="pf_center_box">
       <a href={pfCenterMobileUrl} className="link_made">
         <strong className="tit_made">
           <span className="ico_plus ico_logo" />채널 만들기<span className="ico_plus ico_arr" />
         </strong>
         <p className="desc_made">지금 무료로 만들어 비지니스 홈을 경험하세요</p>
       </a>
     </div>
    )
  }
  
  render() {
    const {
      device,
      isOpenCategory,
      categories,
      eventTop,
      eventMiddle,
      profileRise,
      profileRiseUpdateDate,
      handleOpenCategoryMore,
      profileRiseRenderCount,
      isRiseFetching
    } = this.props;

    return (
      <div className="view_plus">
        <h3 className="screen_out">채널찾기</h3>
        <div className="box_plus" data-tiara-layer="banner_middle_box">
          <PortalBannerSlide events={eventTop}/>
        </div>
        <div className="box_plus" data-tiara-layer="category_box">
          <CategoryList categories={categories} handleOpen={handleOpenCategoryMore} isOpenCategory={isOpenCategory} />
        </div>
        {eventMiddle.size > 0 && (
          <div className="box_plus" data-tiara-layer="banner_middle_box">
            <PortalBanner event={eventMiddle}/>
          </div>
        )}
        {/* PFPROJ-44: 추천, 플친만들기 영역 제거 */}
        {/* {this.renderRecommendsBox()} */}
        {/* {this.renderPfCenterBox()} */}
        <a name="rise" className="anchor"></a>
        <div className="box_plus lst" data-tiara-layer="rise_box">
          <ProfileList
            device={device}
            profiles={profileRise}
            title="친구급상승"
            isNoTitle={Boolean(false)}
            isRankType={Boolean(true)}
            useRenderCount={Boolean(true)}
            renderCount={profileRiseRenderCount}
            subTitle={profileRiseUpdateDate}
            reduxProfileNames={['profileRecommends', 'profileRise']}
          />
        </div>
        <LoadSpinner isFetching={isRiseFetching}/>
      </div>
    );
  }
}

FindFriendView.propTypes = {
  firstTab: PropTypes.string.isRequired,
  scrollTop: PropTypes.number
};

FindFriendView.defaultProps = {
  scrollTop: 0
};


const mapStateToProps = (state, {}) => {
  const { device, portal } = state;
  const pfCenterMobileUrl = portal.get('pfCenterMobileUrl');
  const isOpenCategory = portal.get('isOpenCategory') || false;
  const categories = portal.get('categories') || Immutable.List();
  const eventTop = portal.get('eventTop') || Immutable.List();
  const eventMiddle = portal.get('eventMiddle') || Immutable.Map();
  const profileRecommends = portal.get('profileRecommends') || Immutable.List();
  const profileRise = portal.get('profileRise') || Immutable.List();
  const profileRiseUpdateDate = portal.get('profileRiseUpdateDate') || '';
  const profileRiseRenderCount = portal.get('profileRiseRenderCount') || 20;
  const isRiseFetching = portal.get('isRiseFetching') || false;
  return {
    device,
    pfCenterMobileUrl,
    isOpenCategory,
    categories,
    eventTop,
    eventMiddle,
    profileRecommends,
    profileRise,
    profileRiseUpdateDate,
    profileRiseRenderCount,
    isRiseFetching
  };
};

export default connect(
  mapStateToProps,
  (dispatch) => bindActionCreators({
    handleOpenCategoryMore: actions.updatePortalCategoryMore,
    fetchCategories: actions.fetchCategories,
    fetchEvents: actions.fetchEvents,
    fetchProfilesRecommendRandom: actions.fetchProfilesRecommendRandom,
    fetchProfilesRise: actions.fetchProfilesRise,
    scrollProfileRecommendRequest: actions.scrollProfileRecommendRequest,
    scrollProfileRecommendSuccess: actions.scrollProfileRecommendSuccess,
  }, dispatch)
)(FindFriendView);


// WEBPACK FOOTER //
// ./src/containers/PortalPage/FindFriendView.js